import { useState } from 'react';
import { type ListParams, useCommentList } from '@/hooks/apiHooks';

export const DEFAULT_COMMENT_LIST_PARAMS: ListParams = {
  orderType: 'desc',
  sortType: 'createdAt',
};

const useBoardDetailCommentList = (commentGroupId: string) => {
  const [params, setParams] = useState<ListParams>(DEFAULT_COMMENT_LIST_PARAMS);

  const { data, mutate } = useCommentList(commentGroupId, {
    listSize: 999999,
    currentPage: 1,
    ...params,
  });

  return {
    data: data ?? [],
    mutate,
    params,
    setParams,
  };
};

export default useBoardDetailCommentList;
